/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react';
import { getUploadedImagePath, MarkupRender, useAppDispatch, useAppState } from '@nutastic/nutastic-react-app';
import { useParams } from 'react-router-dom';
import { useNavigation } from '../../hooks/useNavigation';
import { WebsiteActions } from '../../state/actions.mjs';
import ModalPageContainer from '../ModalPageContainer';
import LoadingOverlay from '../LoadingOverlay';
import classnames from 'classnames';
import Footer from '../Footer';

const componentClass = 'customPage';

const CustomPage = () => {
    const appDispatch = useAppDispatch();
    const { isProcessing, pages: { customPages } } = useAppState();
    const { slug } = useParams();
    const { loadPage } = useNavigation();
    const [ currentPage, setCurrentPage ] = useState(null);
    const [isClosing, setIsClosing] = useState(false);

    const classes = classnames( componentClass, 'animated', 'fadeIn' );

    const {
        title,
        content,
        image,
        subtitle
    } = currentPage || {};

    useEffect(() => {
        appDispatch({ type: WebsiteActions.LOADING_PAGE_START });
        setCurrentPage(null);
        const thisPage = customPages.find(p => p?.slug === slug);
        if (thisPage) {
            setCurrentPage(thisPage);
        }
        setTimeout(() => {
            appDispatch({ type: WebsiteActions.LOADING_PAGE_DONE });
        }, 1000);
    }, [])

    const onCloseClick = () => {
        setIsClosing(true);
        loadPage('/');
    };

    return <ModalPageContainer isActive={!isClosing} onClose={onCloseClick}>
        { isProcessing && <LoadingOverlay /> }
        { (currentPage && !isProcessing) && <React.Fragment>
            <article className={classes}>
                <div className="container">
                    <div className={`${componentClass}__headerInfo`}>
                        <h1>{ title }</h1>
                        { subtitle && <p>{ subtitle }</p> }
                    </div>
                    { image && <img src={getUploadedImagePath(image)} alt={`${title} | NuStation.net`} className={`${componentClass}__pageImage`} /> }
                    <MarkupRender className={`${componentClass}__content`} tagName={'div'} content={content}/>
                </div>
            </article>
            <Footer useReducedPadding={true} />
        </React.Fragment>}
    </ModalPageContainer>;
};

export default CustomPage;
